import { render } from "./HelpIconology.vue?vue&type=template&id=ffbac98a&ts=true"
import script from "./HelpIconology.vue?vue&type=script&lang=ts"
export * from "./HelpIconology.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__